import { IonButton, IonCol, IonIcon, IonRow } from "@ionic/react";
import { arrowBackCircleOutline } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { OptionPages } from '../models/apiModels';
import { translation } from "../models/translation";
import { fetchOptions } from "../services/options_service";

interface UserTermsProps {
    goBack: any,
}

const UserTerms: React.FC<UserTermsProps> = ({ goBack }) => {

    const [siteOptions, setSiteOptions] = useState<OptionPages>();

    const siteText=translation()
    const lan=siteText.lan.replace("/","");

    
    
    useEffect(()=>{
        getOptions();
    },[])
    const getOptions = async () => {
        let resp: any = await fetchOptions();
        if (!resp.error) {
            let options: OptionPages = resp.message;
            setSiteOptions(options);
        }
    }

    return (
                <IonRow >
                    <IonCol size="12">
                        <h1 style={{textTransform:'capitalize'}}>{siteText.footLnkTouTxt}</h1>
                    </IonCol>
                    {siteOptions && 
                        <>
                            {lan==='en' && <IonCol size="12" dangerouslySetInnerHTML={{ __html: siteOptions?.acf.userterms_en! }}></IonCol>}
                            {lan==='de' && <IonCol size="12" dangerouslySetInnerHTML={{ __html: siteOptions?.acf.userterms_de! }}></IonCol>}
                            {lan==='fr' && <IonCol size="12" dangerouslySetInnerHTML={{ __html: siteOptions?.acf.userterms_fr! }}></IonCol>}
                        </>
                    }
                    <IonCol size="12">
                        <IonButton onClick={() => { goBack() }} fill="clear"><IonIcon icon={arrowBackCircleOutline}> </IonIcon>Back</IonButton>
                    </IonCol>
                </IonRow>

    )
}

export default UserTerms;